import { Component, ViewEncapsulation } from '@angular/core';
import {UIBlockingService} from "../core/ui-blocking.service";
import {ToastNotificationService} from "../core/toast-notification.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {MemberAdService} from "./member-ad.service";
import {MemberAd} from "./DTOs/member-ad";
import {CommonLibrary} from "../core/common-library";
import {AdUploadResult} from "./DTOs/file-upload-result";
import {AdUpdateRequest} from "./DTOs/ad-update-request";
import {VerifyRejectRequest} from "../core/verify-reject-request";

@Component({
  selector: 'app-pending-ad-details',
  templateUrl: './pending-ad-details.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [UIBlockingService]

})
export class PendingAdDetailsComponent {
  constructor(private pendingAdService: MemberAdService
      , private blockUI: UIBlockingService
      , private notificationService: ToastNotificationService
      , private modalService: NgbModal
      , private route: ActivatedRoute
      , private router: Router) { }

  ad: MemberAd;
    adImage: File = null;
    imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
    maxAdFileSize = 75000; // 75 KB


  ngOnInit() {
    this.refreshAd()
  }

  refreshAd(){
    this.ad = new MemberAd();
    this.route.params.subscribe(params => {
      const adId = +params['id'];
      this.getPendingAd(adId);
    });
  }

  resetModal() {
    this.adImage = null;
  }

  submitUpdatedAd() {
    if (this.adImage == null) return;

    this.blockUI.start();
    this.uploadFile()
        .subscribe({
          next: (data: AdUploadResult) => {
            const updateRequest = new AdUpdateRequest();
            updateRequest.newAdImageId = data.fileStorageId;
            updateRequest.adId = this.ad.adId;
            this.updateMemberAd(updateRequest);
          },
          error: (err) => {
            console.log(err);
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
          },
          complete: () => {
            this.blockUI.stop();
            this.refreshAd();
          }
        });

  }

  updateMemberAd(req: AdUpdateRequest){
    this.pendingAdService.updateMemberAd(req)
        .subscribe({
          next: (data) => {
            console.log('Observable emitted the next value: ' + data);
          },
          error: (err) => {
            console.log(err);
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
          },
          complete: () => {
            console.log('Observable emitted the complete notification');
            this.blockUI.stop();
            this.refreshAd();
          }
        });
  }

  getPendingAd(adId: number) {
      this.blockUI.start();
      this.pendingAdService.getPendingAd(adId).subscribe({
        next: (data) => {
          this.ad = data;
        },
        error: (err) => {
          this.notificationService.error(err.error.message);
          this.blockUI.stop();
          console.log(err)
        },
        complete: () => {
          this.blockUI.stop();
        }
      });
  }

  UpdateStatus(status: number) {
    const req = new VerifyRejectRequest(this.ad.adId.toString(), this.ad.approverNotes);
    this.pendingAdService.changeAdStatus(req, status).subscribe({
      next: (data) => {
      },
      error: (err) => {
        this.blockUI.stop();
        this.notificationService.error(err.error.message);
        console.log(err)
      },
      complete: () => {
        this.blockUI.stop();
        this.router.navigate(['/admin-portal/chamber/pending-ads/']);
      }
    });
  }

    updateAdImageFile(files: FileList) {
    if (!this.imageTypes.includes(files.item(0).type)) {
        this.notificationService.error("File is not a recognized image type.")
        return;
    }
    if (files.item(0).size > this.maxAdFileSize) {
        this.notificationService.error("File is larger than the maximum file size.");
        return;
    }
    this.adImage = files.item(0);
  }

  uploadFile() {
    const uploadData = new FormData();
    uploadData.append('mainImage', this.adImage, this.adImage.name);
    return this.pendingAdService.uploadAdFile(uploadData);
  }


  protected readonly CommonLibrary = CommonLibrary;
}
